<template>
  <div>
    <div v-show="showTrack" :style="{width:CWidth,height:CHeight}" class="zwibbler-outer">
      <div id="zwibbler" :style="{width:CWidth,height:CHeight}" style="margin-left:auto;margin-right:auto;">
      </div>
      <div :style="bottom ? 'bottom:' + bottom : ''" class="zwi-tool" id="zwi-tool">
        <el-popover
          placement="bottom"
          trigger="click"
          width="200">
          <el-button slot="reference" class="zwi-tool-btn-1">
            <img src="@/assets/img/zwi/color.png">
            <div :style="'background:' + color" class="color-show"></div>
          </el-button>
          <div class="color_tool">
            <div class="color_item" style="background:red" @click="selectColor('red')"></div>
            <div class="color_item" style="background:#33CC33" @click="selectColor('#33CC33')"></div>
            <div class="color_item" style="background:#0099FF" @click="selectColor('#0099FF')"></div>
            <div class="color_item" style="background:#FF9933" @click="selectColor('#FF9933')"></div>
            <div class="color_item" style="background:#CC3366" @click="selectColor('#CC3366')"></div>
            <div class="color_item" style="background:#CC0033" @click="selectColor('#CC0033')"></div>
          </div>
        </el-popover>
        <el-button :class="toolName == 'text' ? 'act':''" class="zwi-tool-btn iconfont icon-pizhu-wenben" @click.native="text"></el-button>
        <el-button :class="toolName == 'pen' ? 'act':''" class="zwi-tool-btn iconfont icon-pizhu-huabi" @click.native="pen(true)"></el-button>
        <el-button :class="toolName == 'arrow' ? 'act':''" class="zwi-tool-btn iconfont icon-pizhu-jiantou" @click.native="arrow"></el-button>
        <el-button :class="toolName == 'line' ? 'act':''" class="zwi-tool-btn iconfont icon-pizhu-zhixian" @click.native="line"></el-button>
        <el-button :class="toolName == 'circle' ? 'act':''" class="zwi-tool-btn iconfont icon-pizhu-yuanxing" @click.native="yuan"></el-button>
        <el-button :class="toolName == 'rectangle' ? 'act':''" class="zwi-tool-btn iconfont icon-pizhu-juxing" @click.native="rect"></el-button>
        <div class="tool-line"></div>
        <el-button class="zwi-tool-btn iconfont icon-xiangpi" @click.native="eraser"></el-button>
        <el-button class="zwi-tool-btn iconfont icon-pizhu-chehui" @click.native="back"></el-button>
        <el-button class="zwi-tool-btn iconfont icon-pizhu-zhongzuo" @click.native="reBack"></el-button>
        <el-button class="zwi-tool-btn iconfont icon-pizhu-qingkonghuaban" @click.native="clear"></el-button>
        <img class="hide-btn" src="@/assets/img/zwi/hide.png" @click="showTrackChange(false)">
      </div>
    </div>
    <div v-show="!showTrack" :style="{width:CWidth,height:CHeight}" class="zwibbler-outer" style="pointer-events: none">
      <div :style="{width:CWidth,height:CHeight}"></div>
      <div :style="bottom ? 'bottom:' + bottom : ''" class="zwi-tool" style="justify-content: end;background: none;backdrop-filter: none;pointer-events: all !important;">
        <img class="hide-btn"  src="@/assets/img/zwi/show.png" @click="showTrackChange(true)">
      </div>
    </div>
<!--    <div v-show="!showTrack"  :style="bottom ? 'bottom:' + bottom : ''" class="zwi-tool" style="justify-content: end;background: none;backdrop-filter: none">-->
<!--      <img class="hide-btn"  src="@/assets/img/zwi/show.png" @click="showTrackChange(true)">-->
<!--    </div>-->
  </div>
</template>

<script>
import {Zwibbler} from "@/assets/js/zwibbler";

export default {
  name: "Zwibbler",
  data() {
    return {
      zwibbler: {},
      showColor: false,
      color: 'red',
      CWidth: this.width + 'px',
      CHeight: this.height + 'px',
      scaleSize: 1,
      dataInfo: {},
      toolActivity: '',
      showTrack: true,
      toolName:'brush'
    }
  },
  props: {
    dataInfo1: undefined,
    height: '',
    width: '',
    bottom: null,
  },
  watch: {
    dataInfo1(val1, val2) {
      console.log(val2)
      if (Object.prototype.toString.call(val2) === '[object Object]') {
        this.dataInfo = val2
      } else {
        this.dataInfo.imgSrc = val2
      }
    }
  },
  mounted() {
    console.log(this.width)
    console.log(this.height)
    this.init()
  },
  methods: {
    init(type) {
      this.zwibbler = Zwibbler.create("zwibbler", {
        showToolbar: false,
        defaultBrushWidth: 2,
        showColourPanel: false,
        autoPickTool:false,
        scrollbars: false,
        allowResize: true,
        maximumZoom: 1, // 最大放大倍数
        minimumZoom: 1 // 最小搜小倍数
      });
      if (Object.prototype.toString.call(this.dataInfo1) === '[object Object]') {
        this.dataInfo = this.dataInfo1
      } else {
        this.dataInfo.imgSrc = this.dataInfo1
      }
      if (type !== 'clear') {
        this.zwibbler.setConfig("backgroundImage", this.dataInfo.imgSrc);
      }
      // 监听工具的使用
      var _that = this
      this.zwibbler.on('tool-changed',function (toolName) {
        _that.toolName = toolName
      })

    },
    showTrackChange(val) {
      this.showTrack = val
      this.$emit('showTrack', val)
    },
    selectColor(color) {
      this.color = color;
      this.showColor = false;
      this.pen();
    },
    scale(type) {
      if (type == -1) {//缩小
        this.zwibbler.zoomOut()
      }
      if (type == 1) {//放大
        this.zwibbler.zoomIn()
      }
    },
    eraser() {
      this.zwibbler.useBrushTool({
        lineWidth: 30,
        strokeStyle: "erase",
        // optional: prevents the user from being able to move the erase stroke.
        layer: "my_eraser_layer"
      });
    },
    pen() {
      this.zwibbler.useBrushTool(
        {
          lineWidth: 4,
          strokeStyle: this.color
        }
      );
      setTimeout(()=>{
        this.toolName = 'pen'
      },100)
    },
    arrow() {
      this.zwibbler.useArrowTool({
        strokeStyle: this.color,
        lineWidth: 4
      }, true)
    },
    line() {
      this.zwibbler.useLineTool({
        strokeStyle: this.color,
        lineWidth: 4
      }, true)
    },
    yuan() {
      this.zwibbler.useCircleTool({
        strokeStyle: this.color,
        fillStyle: 'transparent',
        lineWidth: 4
      }, {})
    },
    text() {
      this.zwibbler.useTextTool({
        strokeStyle: this.color,
        fillStyle: this.color,
        wrap: true,
      }, true);
    },
    rect() {
      this.zwibbler.useRectangleTool({
        lineWidth: 2,
        strokeStyle: this.color,
        fillStyle: 'transparent',
      }, {});
    },
    back() {
      this.zwibbler.undo();
    },
    reBack() {
      this.zwibbler.redo();
    },
    clear() {
      this.$confirm('清空批注后无法撤回操作，请谨慎选择', '清空所有批注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.zwibbler.destroy();
        this.init('clear');
      })
    },
    saveTu() {
      let base64String = this.zwibbler.save('png', {x: 0, y: 0, width: this.width, height: this.height})
      const data = window.atob(base64String.split(",")[1]);
      const ia = new Uint8Array(data.length);
      for (let i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i);
      }
      const blob = new Blob([ia], {type: "image/png"}); // blob 文件
      return blob
    },
  }
}
</script>

<style scoped src="../assets/css/zwibbler.css"></style>

<style>
.zwi-tool-btn,.zwi-tool-btn-1{
  border: none;
  width: 44px;
  height: 44px;
  padding: 0;
  background: transparent;
  color: #ffffff;
  font-size: 32px;
  text-align: center;
  line-height: 44px;
}
.zwi-tool a{
  text-decoration: none;
}
</style>
